import { FixDictionary } from "./model/dictionary/FixDictionary";
import { FixMessage } from "./model/FixMessage";
import { FixParser } from "./FixParser";
import { DictionaryLoader } from "./model/dictionary/DictionaryLoader";
import { FixTag } from "./model/FixTag";

class FixValidator {
  private parser: FixParser;

  private validateTag(tag: FixTag, dictionary: FixDictionary) {
    tag.type = dictionary.tags[tag.num];
    tag.valid = true;
    if (!tag.type) {
      tag.valid = false;
      tag.errors.push("Unknown Tag");
    } else {
      const typeName = tag.type.t;
      if (!!tag.type.v) {
        if (!tag.type.v[tag.value]) {
          tag.valid = false;
          tag.warnings.push("Unknown Enum Value");
        }
      } else {
        tag.valid = this.validateValueType(tag, typeName) && tag.valid;
      }
    }
    return tag.valid;
  }

  private validateValueType(tag: FixTag, typeName: string) {
    const value = tag.value;
    let result = true;
    switch (typeName) {
      case "STRING":
      case "DATA":
        result = typeof value == "string" && value.length > 0;
        break;
      case "CHAR":
        result = typeof value == "string" && value.length === 1;
        break;

      case "INT":
        result = FixValidator.isInt(value);
        break;

      case "LENGTH":
        result = FixValidator.isUInt(value);
        break;

      case "FLOAT":
      case "QTY":
      case "PRICE":
      case "PRICEOFFSET":
      case "AMT":
      case "PERCENTAGE":
        result = FixValidator.isFloat(value);
        break;

      case "CURRENCY":
        result = FixValidator.isCurrency(value);
        break;

      case "COUNTRY":
        result = FixValidator.isCountry(value);
        break;
    }
    if (!result) {
      tag.errors.push(`${typeName}  Value Expected`);
      return false;
    } else {
      return true;
    }
  }

  private static isInt(value: string) {
    return /^-?\d+$/.test(value);
  }

  private static isUInt(value: string) {
    return /^\d+$/.test(value);
  }

  private static isCurrency(value: string) {
    return /^[A-Z]{3}$/.test(value);
  }

  private static isCountry(value: string) {
    return /^[A-Z]{2}$/.test(value);
  }

  private static isFloat(value: string) {
    return /^-?\d+(\.\d+)?$/.test(value);
  }

  constructor(p: FixParser) {
    this.parser = p;
  }

  private validateInternal(msg: FixMessage, dict: FixDictionary) {
    msg.dictionary = dict;
    const messageType = dict.messages[msg.msgType.value];
    for (let i = 0; i < msg.tags.length; ) {
      const tag = msg.tags[i++];
      msg.valid = this.validateTag(tag, dict) && msg.valid;
    }
    if (!messageType) {
      msg.valid = false;
      msg.errors.push(`Unsupported Message Type: "${msg.msgType.value}"`);
    }
  }

  public validateMessage(msg: FixMessage, dialect: string) {
    // ts-ignore
    return DictionaryLoader.getDictionary(dialect, this.parser.jsPrefix)?.then(
      (dict) => {
        this.validateInternal(msg, dict);
        this.parser.onMessageParsed(msg);
      },
      (reason) => {
        console.debug("Failed to fetch dictionary:", dialect, reason);
        msg.valid = false;
        this.parser.onMessageParsed(msg);
      }
    );
  }
}

export { FixValidator };
